import questsApi from "@/api/quests/client";
import useInfiniteQuests from "./useInfiniteQuests";

const useUncompletedQuests = () => {
  const { quests, hasNextPage, fetchNextPage } = useInfiniteQuests(
    "uncompleted-quests",
    questsApi.getMyUncompletedQuests,
  );

  return {
    uncompletedQuests: quests,
    hasNextPage,
    fetchNextPage,
  };
};

export default useUncompletedQuests;
